/*
 * Medication deletion helper
 * Check editingDocument and if it exists, add documentID to redux state so that toolbar displays the delete icon
 *
 * TODO: is there a better way to do this instead of a class that returns nothing?
 */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setDeleteId, clearDeleteId } from 'store/document/actions';

class MedicationDeletionHandler extends React.Component {
  handleDelete = () => {
    const { editingDocument, dispatch } = this.props;
    if (editingDocument && editingDocument.firstCommitTime) {
      dispatch(setDeleteId(editingDocument.documentType, editingDocument.documentId));
    } else {
      dispatch(clearDeleteId('medication'));
      dispatch(clearDeleteId('vitamin'));
    }
  };

  componentDidMount() {
    this.handleDelete();
  }

  componentDidUpdate() {
    this.handleDelete();
  }

  render() {
    return null;
  }
}

MedicationDeletionHandler.propTypes = {
  editingDocument: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  dispatch: PropTypes.func,
};

export default connect()(MedicationDeletionHandler);
